export default __webpack_public_path__ + "static/media/logo_tss.56f79052.svg";